<div class="browse-carousel">
  <app-horizontal-scroller [itemType]="itemType">
    <div
      class="scroll-wrapper"
      [ngClass]="{
        'with-thumbnail':
          itemType === CarouselItem.Video ||
          itemType === CarouselItem.Gps ||
          itemType === CarouselItem.Workout ||
          itemType === CarouselItem.Coaching,
        'with-detail':
          itemType === CarouselItem.VideoDetail ||
          itemType === CarouselItem.GpsDetail ||
          itemType === CarouselItem.WorkoutDetail ||
          itemType === CarouselItem.CoachingDetail,

        'with-playlist': itemType === CarouselItem.Playlist,
        'with-poster': itemType === CarouselItem.VideoPoster,
      }">
      <div class="cards-container">
        @if (
          itemType === CarouselItem.Video ||
          itemType === CarouselItem.VideoDetail
        ) {
          <ng-container>
            @for (video of videos; track $index) {
              <div class="card-container">
                <div
                  class="inner-card"
                  (mouseenter)="onSelectOrUnselectVideo(video.id)"
                  (mouseleave)="onSelectOrUnselectVideo()">
                  <kin-scenic-card
                    (onCardClick)="redirect(video.id, 'browse')"
                    (onAuthorClick)="redirect(video.author.id, 'author')"
                    (onFavoriteClick)="onLikeClick(video, BrowseTypes.Video)"
                    [information]="video"
                    [details]="itemType === CarouselItem.VideoDetail"
                    [size]="
                      (smallScreen$ | async) || (xSmallScreen$ | async)
                        ? 'small'
                        : 'medium'
                    "
                    class="pointer" />
                </div>
              </div>
            }
          </ng-container>
        }
        @if (
          itemType === CarouselItem.Gps || itemType === CarouselItem.GpsDetail
        ) {
          <ng-container>
            @for (gpsTrack of gpsTracks; track $index) {
              <div class="card-container">
                <div class="inner-card">
                  <kin-scenic-card
                    (onCardClick)="redirect(gpsTrack.id, 'browse')"
                    (onAuthorClick)="redirect(gpsTrack.author.id, 'author')"
                    (onFavoriteClick)="
                      onLikeClick(gpsTrack, BrowseTypes.GpsTrack)
                    "
                    [information]="gpsTrack"
                    [details]="itemType === CarouselItem.GpsDetail"
                    [size]="
                      (smallScreen$ | async) || (xSmallScreen$ | async)
                        ? 'small'
                        : 'medium'
                    "
                    class="pointer" />
                </div>
              </div>
            }
          </ng-container>
        }
        @if (
          itemType === CarouselItem.Workout ||
          itemType === CarouselItem.WorkoutDetail
        ) {
          <ng-container>
            @for (workout of workouts; track $index) {
              <div class="card-container">
                <div class="inner-card">
                  <kin-scenic-card
                    (onCardClick)="redirect(workout.id, 'browse')"
                    (onAuthorClick)="redirect(workout.author.id, 'author')"
                    (onFavoriteClick)="
                      onLikeClick(workout, BrowseTypes.Workout)
                    "
                    [information]="workout"
                    [details]="itemType === CarouselItem.WorkoutDetail"
                    [size]="
                      (smallScreen$ | async) || (xSmallScreen$ | async)
                        ? 'small'
                        : 'medium'
                    "
                    class="pointer"></kin-scenic-card>
                </div>
              </div>
            }
          </ng-container>
        }
        @if (
          itemType === CarouselItem.Coaching ||
          itemType === CarouselItem.CoachingDetail
        ) {
          <ng-container>
            @for (coaching of coachings; track $index) {
              <div class="card-container">
                <div class="inner-card">
                  <kin-scenic-card
                    (onCardClick)="redirect(coaching.id, 'browse')"
                    (onAuthorClick)="redirect(coaching.author.id, 'author')"
                    (onFavoriteClick)="
                      onLikeClick(coaching, BrowseTypes.Coaching)
                    "
                    [information]="coaching"
                    [details]="itemType === CarouselItem.CoachingDetail"
                    [size]="
                      (smallScreen$ | async) || (xSmallScreen$ | async)
                        ? 'small'
                        : 'medium'
                    "
                    class="pointer" />
                </div>
              </div>
            }
          </ng-container>
        }
        @if (itemType === CarouselItem.Playlist) {
          <ng-container>
            @for (playlist of playlists; track $index) {
              <div class="card-container">
                <kin-playlist-card
                  class="inner-card"
                  (onCardClick)="redirect($event, 'browse')"
                  [playlist]="playlist"
                  (onAuthorClick)="redirect(playlist.author.id, 'author')"
                  (onFavoriteClick)="
                    onLikeClick(playlist, BrowseTypes.Playlist)
                  " />
              </div>
            }
          </ng-container>
        }
        @if (itemType === CarouselItem.VideoPoster) {
          <ng-container>
            @for (video of videos; track $index) {
              <div class="card-container">
                <a
                  [routerLink]="['/browse/watch/', video.id]"
                  class="inner-card"
                  (mouseenter)="onSelectOrUnselectVideo(video.id)"
                  (mouseleave)="onSelectOrUnselectVideo()">
                  <app-video-poster-card
                    [video]="video"
                    [title]="video.name"
                    [rank]="videos.indexOf(video) + 1"
                    [isVideoPreview]="
                      selectedVideo && selectedVideo.id === video.id
                    "
                    class="pointer" />
                </a>
              </div>
            }
          </ng-container>
        }
      </div>
    </div>
  </app-horizontal-scroller>
</div>
